export const convertToBase64 = (imageFile) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(imageFile);
    reader.onload = () => {
      resolve(reader.result);
    };
  });
};
